export default __webpack_public_path__ + "static/media/event-normal.c75858ad.svg";